import React from "react"

const ProgressGraph = ({ ks1Value = 0, currentValue = 0 }) => {
  return (
    <div className="ProgressGraph">
      <svg width="540" height="243">
        <g transform="translate(75, 7.5)">
          <path d="M0 215.461H60.4838C60.63 172.262 78.3856 133.209 106.954 105.116L64.1839 62.3438C24.6733 101.386 0.141507 155.555 0 215.461Z" fill="#F34970" />
          <path d="M64.1836 62.3419L106.954 105.114C135.018 77.511 173.51 60.4838 215.981 60.4838V0C156.808 0 103.198 23.7987 64.1836 62.3419Z" fill="#F4C900" />
          <path d="M215.98 0V60.4838C258.927 60.4838 297.804 77.8961 325.945 106.037L368.715 63.2722C349.173 43.7257 325.897 27.907 300.057 16.9762C274.219 6.04305 245.804 0 215.98 0Z" fill="#AABB5D" />
          <path d="M325.945 106.037C353.966 134.062 371.337 172.735 371.478 215.459H431.96C431.82 156.028 407.678 102.244 368.715 63.2715L325.945 106.037Z" fill="#26C8B9" />
          <g className="line" transform={`translate(216, 210) rotate(${((-100 + ks1Value) * 180 / 100) - 90})`}>
            <svg className="dotted-graph-line" width="3" height="212" viewBox="0 0 3 354" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="1.47266" y1="353.473" x2="1.47266" y2="0.527376" stroke="#084059" strokeWidth="2" strokeDasharray="2 2" />
            </svg>
          </g>
          <g className="needle" transform={`translate(215, 210) rotate(${(currentValue * 180 / 100) - 120})`}>
            <path d="M-9.2714657085651 -18.542391906386012L81.92327852283093 -140.79110322113758L9.271465708565099 3.9623919063860145" fill="#084059"></path>
            <circle cx="0" cy="-7.29" r="20.58" fill="#084059"></circle>
          </g>
          <g transform={"translate(0, 208)"}>
            <svg className="blueGraphBar" width="430" height="16" viewBox="0 0 816 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.9707L808 7.9707" stroke="#084059" strokeWidth="15" strokeLinecap="round" />
            </svg>
          </g>
        </g>
      </svg>
    </div>
  )
}

export { ProgressGraph }